import axios from '@/libs/axios'
import helpers from '@/libs/helper'
import store from '@/store'

import permissionActions from '@/store/rekordlista/actions/permissionActions'
import roleActions from '@/store/rekordlista/actions/roleActions'
import appActions from '@/store/rekordlista/actions/appActions'
import authActions from '@/store/rekordlista/actions/authActions'
import userActions from '@/store/rekordlista/actions/userActions'
import fileActions from '@/store/rekordlista/actions/fileActions'
import logActions from '@/store/rekordlista/actions/logActions'
import fishermanActions from "@/store/rekordlista/actions/fishermanActions";
import fishCategoryActions from '@/store/rekordlista/actions/fishCategoryActions'
import fishTypeActions from '@/store/rekordlista/actions/fishTypeActions'
import baitActions from '@/store/rekordlista/actions/baitActions'
import waterActions from '@/store/rekordlista/actions/waterActions'
import recordCatchActions from '@/store/rekordlista/actions/recordCatchActions'
import textTemplateActions from '@/store/rekordlista/actions/textTemplateActions'
import emailTemplateActions from '@/store/rekordlista/actions/emailTemplateActions'
import optionActions from '@/store/rekordlista/actions/optionActions'
import dashboardActions from '@/store/rekordlista/actions/dashboardActions'

// setup axios
axios.interceptors.request.use(
    config => {
        const accessToken = store.state.token
        if (accessToken) {
            config.headers.Authorization = `Bearer ${accessToken}`
        }
        // TODO: basic auth
        if (process.env.NODE_ENV === 'development') console.log('Interceptor request[',config.method , '+',config.url ,']', config);
        return config
    },
    error => {
        // Do something with request error
        helpers.showErrorToast('', 'Ismeretlen hiba! Keresse fel az oldal üzemeltetőjét')
        if (process.env.NODE_ENV === 'development') console.error('Interceptor request error: ', error);
        return Promise.reject(error)
    },
)

axios.interceptors.response.use(
    //If we have a response from our recent http call
    (response) => {
        if (process.env.NODE_ENV === 'development') console.log('Interceptor response[',response.config.method , '+',response.config.url ,']', response);
        return response;
    },
    (error) => {
        if (error.response.status === 401) {
            helpers.showErrorToast('Lejárt munkamenet!')
            helpers.logout()
            // eslint-disable-next-line no-underscore-dangle
        }
        //Catches 403 error from our axios request
        if (process.env.NODE_ENV === 'development') console.error('Interceptor response error: ', error);
        return Promise.reject(error);
    }
);

const actions = {
    ...permissionActions,
    ...roleActions,
    ...appActions,
    ...authActions,
    ...userActions,
    ...fileActions,
    ...logActions,
    ...fishermanActions,
    ...fishCategoryActions,
    ...fishTypeActions,
    ...baitActions,
    ...waterActions,
    ...recordCatchActions,
    ...textTemplateActions,
    ...emailTemplateActions,
    ...optionActions,
    ...dashboardActions,
}

export default actions
